import api from '../api/axios';

const getAll = (params = {}) => {
  return api.get('/discounts', { params });
};

const getById = (id) => {
  return api.get(`/discounts/${id}`);
};

const create = (data) => {
  return api.post('/discounts', data);
};

const update = (id, data) => {
  return api.patch(`/discounts/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/discounts/${id}`);
};

const restore = (id) => {
  return api.get(`/discounts/${id}/restore`);
};

const discountsServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  restore,
};

export default discountsServices;
